import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import useSound from 'use-sound';
import LocationNotification from '../../modals/LocationNotification';
import NewOrderModal from '../../modals/NewOrder';
import RestrictedArea from '../../../../components/layout/RestrictedArea';
import TastySound from '../../../../assets/Tasty.mp3';
import SaucySound from '../../../../assets/Saucy.mp3';
import FlavorySound from '../../../../assets/Flavory.mp3';
import {GET_LOCATION_ID_DATA} from '../../../../store/orders/orderList/action';
import BookADriverDeliverySuccessModal from '../../BookADriver/Modals/DeliverySuccess';
import BADCourierModal from '../../BookADriver/Modals/BADCourierModal';
import OrderSuccess from '../../BookADriver/Modals/OrderSuccess';
import {
  FEATURE_RESTRICTION_IDS,
  getBookADriverRestriction
} from '../../../../helpers/constants/restrictions';
import NewOrderModalV2 from '../../modals/NewOrderV2';
import LargeDeliveryModal from '../../modals/LargeDelivery';
import {HANDLE_SUCCESS_MODAL} from '../../../../store/bookADriver/bookADriverCreate/action';

export default function Notifications() {
  const dispatch = useDispatch();
  const {
    locationData: {OrderNotifications}
  } = useSelector((state) => state.ordersHistoryReducer);
  const {
    locationData: {OrderNotifications: OrderNotificationsV2}
  } = useSelector((state) => state.ordersHistoryV2Reducer);

  useEffect(() => {
    if (
      !Object.keys(OrderNotifications).length &&
      !Object.keys(OrderNotificationsV2).length
    ) {
      dispatch(GET_LOCATION_ID_DATA());
    }
  }, []);

  const serviceFeatures = useSelector(
    (state) => state.user?.activeLocation?.AllowedServiceFeatures
  );
  const timezoneId = useSelector(
    (state) => state.user?.activeLocation?.TimezoneId || 'America/New_York'
  );
  const openSuccessModal = useSelector(
    (state) => state.bookADriverCreateReducer.openSuccessModal
  );
  const successData = useSelector(
    (state) => state.bookADriverCreateReducer.successData
  );

  const [playTastySound, exposedTastySound] = useSound(TastySound, {
    loop: true
  });
  const [playSaucySound, exposedSaucySound] = useSound(SaucySound, {
    loop: true
  });
  const [playFlavorySound, exposedFlavorySound] = useSound(FlavorySound, {
    loop: true
  });

  const soundsActions = {
    Tasty: {play: playTastySound, stop: exposedTastySound.stop},
    Saucy: {play: playSaucySound, stop: exposedSaucySound.stop},
    Flavory: {play: playFlavorySound, stop: exposedFlavorySound.stop}
  };

  const onSoundStop = () => {
    let soundName;
    if (serviceFeatures.includes('orders')) {
      soundName = OrderNotifications.RingSoundName;
    }
    if (
      serviceFeatures.includes('orders_v2') ||
      serviceFeatures.includes('show_byoc_events')
    ) {
      soundName = OrderNotificationsV2.RingSoundName || 'Flavory';
    }
    soundsActions[soundName || 'Saucy'].stop();
  };

  useEffect(() => {
    return () => {
      onSoundStop();
    };
  }, []);

  const onHandlePlay = () => {
    let soundName;
    if (serviceFeatures.includes('orders')) {
      soundName = OrderNotifications.RingSoundName;
    }
    if (
      serviceFeatures.includes('orders_v2') ||
      serviceFeatures.includes('show_byoc_events')
    ) {
      soundName = OrderNotificationsV2.RingSoundName || 'Flavory';
    }
    soundsActions[soundName || 'Saucy'].play();
  };
  return (
    <>
      <RestrictedArea
        restrictions={[]}
        features={[FEATURE_RESTRICTION_IDS.STORE_SETTINGS]}
      >
        <LocationNotification />
      </RestrictedArea>
      <RestrictedArea
        restrictions={['ordersAlert']}
        features={[getBookADriverRestriction(serviceFeatures)]}
      >
        <BookADriverDeliverySuccessModal />
        <BADCourierModal />
        <OrderSuccess
          open={openSuccessModal}
          data={successData}
          timezoneId={timezoneId}
          onClose={() =>
            dispatch(
              HANDLE_SUCCESS_MODAL({
                openSuccessModal: false,
                successData: {}
              })
            )
          }
        />
      </RestrictedArea>
      <RestrictedArea
        restrictions={['ordersAlert']}
        features={[FEATURE_RESTRICTION_IDS.ORDERS]}
      >
        <NewOrderModal play={onHandlePlay} onSoundStop={onSoundStop} />
      </RestrictedArea>
      <RestrictedArea
        restrictions={['ordersAlert']}
        features={[FEATURE_RESTRICTION_IDS.ORDERS_V2]}
      >
        <NewOrderModalV2 play={onHandlePlay} onSoundStop={onSoundStop} />
      </RestrictedArea>
      <RestrictedArea
        restrictions={['ordersAlert']}
        features={[
          FEATURE_RESTRICTION_IDS.ORDERS_V2,
          FEATURE_RESTRICTION_IDS.BOOK_A_DRIVER_V2,
          FEATURE_RESTRICTION_IDS.LARGE_DELIVERY
        ]}
      >
        <LargeDeliveryModal />
      </RestrictedArea>
      <RestrictedArea
        restrictions={['ordersAlert']}
        features={[FEATURE_RESTRICTION_IDS.SHOW_BYOC_EVENTS]}
      >
        <NewOrderModalV2 play={onHandlePlay} onSoundStop={onSoundStop} />
      </RestrictedArea>
    </>
  );
}
